import React, { useState, useEffect } from "react"
import { Link, navigate } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../components/layout"
import Seo from "../components/seo"
import { tangaBasa } from "../shonascript/index"
import { IoCaretForwardCircleOutline } from "@react-icons/all-files/io5/IoCaretForwardCircleOutline"
import { IoHelpCircleOutline } from "@react-icons/all-files/io5/IoHelpCircleOutline"
import { IoCloseSharp } from "@react-icons/all-files/io5/IoCloseSharp"
import { IoMenuOutline } from "@react-icons/all-files/io5/IoMenuOutline"
import { useMediaQuery } from "react-responsive"
import AboutModal from "../components/aboutModal"

import Navigation from "./Navigation/Navigation"

const Code = props => {
  const [numberOfLines, setNumberOfLines] = useState([1])
  const [currentLines, setCurrentLines] = useState()
  const [scrollT, setScrollT] = useState()

  // screen orientations
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  })
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" })
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" })
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" })
  const isRetina = useMediaQuery({ query: "(min-resolution: 2dppx)" })

  const showData = () => {
    if (typeof document !== `undefined`) {
      let x = document.querySelector("#code").innerText
      setCurrentLines(x)
      let lines = x.split("\n")
      let y = lines.length
      let array = [...Array(y).keys()].map(x => x + 1)
      setNumberOfLines(array)
    }
  }

  useEffect(() => {
    if (typeof window !== `undefined`) {
    let currentCode = localStorage.getItem(props.localStorageOriginalCode)
    if (currentCode) {
      if (typeof document !== `undefined` && document.querySelector("#code")) {
        document.querySelector("#code").innerText = currentCode
        let lines = currentCode.split("\n")
        let y = lines.length
        let array = [...Array(y).keys()].map(x => x + 1)
        setNumberOfLines(array)
      }
    }
  }
  }, [])

  useEffect(() => {
    // console.log(currentLines)
  }, [currentLines])

  // run the code and save it to the local storage
  const runCode = () => {
    if (typeof window !== `undefined`) {
      document.querySelector("#code").innerHTML =  document.querySelector("#code").innerHTML.replace(/&nbsp;/g, " ")
      let x = document.querySelector("#code").innerText
      localStorage.setItem(props.localStorageOriginalCode, x) // save teh current code to the local storage
      let result = props.mainFunction(x)

      localStorage.setItem(props.localStorageCode, JSON.stringify(result)) // save to the local storage
      navigate(props.to)
    }
  }

  const scrollLines = e => {
    // console.log(e.target.scrollTop)
    setScrollT(e.target.scrollTop)
  }

  // scroll the lines div
  useEffect(() => {
    if (typeof document !== `undefined`) {
      let y = document.querySelector(".shouldScroll")
      y.scrollTo(0, scrollT)
    }
  }, [scrollT])

  // show modal
  const showModal = () => {
    let modal = document.querySelector(`.modal_background`)
    modal.style.display = "block"
  }

  // set the pictures
  useEffect(() => {
    
    let pictures = localStorage.getItem("dhaga-pictures")
    pictures = JSON.parse(pictures);
    if(!pictures){
      pictures = []
    }
    if(!pictures.includes('/dhaga-pictures/1.jpg')){
      let defaultPics = [1,2,3,4,5,6];
      defaultPics.map(x=> {
        pictures.push(`/dhaga-pictures/${x}.jpg`)
      });
    }
    localStorage.setItem('dhaga-pictures', JSON.stringify(pictures));


  }, [])

  return (
    <div
      className="flex flex-col h-screen w-full font-jb overflow-hidden"
      style={{ backgroundColor: "#FFEDC4" }}
    >
      <AboutModal showModal={showModal} />
      <div className="flex flex-col h-5/6">
        <div className="h-1/6 flex ">
          <div className="w-1/12 bg-shona h-full text-shona"></div>
          <div className="w-11/12 flex justify-center bg-white">
            <img src={props.logo} style={{ transform: "scale(0.8)" }}></img>
          </div>
        </div>
        <div className="flex h-5/6 w-full b-b-2">
          <div className="w-1/12 bg-shona rounded-bl-xl overflow-scroll shouldScroll h-full">
            {numberOfLines.map(x => (
              <div className="pl-2 text-white lg:text-right lg:pr-5">{x}</div>
            ))}
          </div>
          <div
            contentEditable="true"
            onKeyUp={showData}
            onScroll={scrollLines}
            id="code"
            className="w-11/12 h-full overflow-x-scroll whitespace-nowrap pl-2 bg-white"
          ></div>
        </div>
      </div>

      <div className="h-1/6 mt-5">
        <div className="flex justify-center w-full">
          <button
            onClick={runCode}
            className="bg-shona p-3 rounded-full shadow-lg text-3xl text-white"
          >
            <IoCaretForwardCircleOutline />
          </button>
        </div>
        <Navigation />
      </div>
    </div>
  )
}

export default Code
